import { Check, Package, Cog, Truck, Home, XCircle } from "lucide-react";

const STEPS = [
  { key: "ordered", label: "Ordered", icon: Package },
  { key: "processing", label: "Processing", icon: Cog },
  { key: "shipped", label: "Shipped", icon: Truck },
  { key: "delivered", label: "Delivered", icon: Home },
];

// Maps an order's fulfillment/status to the current step index (0..3).
const stepIndex = (order) => {
  const s = (order.fulfillment_status || order.status || "processing").toLowerCase();
  if (s === "delivered") return 3;
  if (s === "shipped" || s === "out_for_delivery" || s.includes("transit")) return 2;
  if (s === "processing" || s === "packed") return 1;
  return 0; // ordered / pending
};

export const OrderProgressBar = ({ order }) => {
  const cancelled = (order.fulfillment_status || order.status || "").toLowerCase() === "cancelled";
  const current = stepIndex(order);
  const pct = cancelled ? 0 : (current / (STEPS.length - 1)) * 100;

  if (cancelled) {
    return (
      <div data-testid={`progress-${order.order_id}`} className="flex items-center gap-2 rounded-xl bg-red-50 text-red-600 px-4 py-3">
        <XCircle className="w-5 h-5" /><span className="font-semibold text-sm">This order was cancelled</span>
      </div>
    );
  }

  return (
    <div data-testid={`progress-${order.order_id}`} className="pt-2 pb-1">
      <div className="relative">
        {/* base + filled bar */}
        <div className="absolute left-0 right-0 top-4 h-1.5 rounded-full bg-muted" />
        <div className="absolute left-0 top-4 h-1.5 rounded-full bg-gradient-to-r from-orange-500 to-amber-500 transition-all duration-700" style={{ width: `${pct}%` }} />
        <div className="relative flex justify-between">
          {STEPS.map((step, i) => {
            const done = i < current;
            const active = i === current;
            const Icon = step.icon;
            return (
              <div key={step.key} className="flex flex-col items-center gap-2 flex-1" data-testid={`step-${step.key}`}>
                <div className={`w-9 h-9 rounded-full flex items-center justify-center border-2 transition-all duration-300 z-10
                  ${done ? "bg-orange-500 border-orange-500 text-white" : active ? "bg-white border-orange-500 text-orange-500 ring-4 ring-orange-100 scale-110" : "bg-white border-muted text-muted-foreground"}`}>
                  {done ? <Check className="w-4 h-4" /> : <Icon className="w-4 h-4" />}
                </div>
                <span className={`text-[11px] sm:text-xs text-center ${done || active ? "font-semibold text-foreground" : "text-muted-foreground"}`}>{step.label}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
